import { useRef, useState } from "react";
import { toast } from "react-toastify";

const NotificationItem = ({
  notification,
  index,
  onMarkAsRead,
  onDelete,
  onUndo,
  onRestore,
}) => {
  const [isHidden, setIsHidden] = useState(false);
  const timeoutRef = useRef(null);

  const handleDelete = async () => {
    await onDelete(notification.id); // Delete from backend
    setIsHidden(true); // Hide from UI immediately

    const toastId = toast(
      ({ closeToast }) => (
        <div>
          Notification deleted.{" "}
          <button
            className="btn btn-link btn-sm p-0"
            onClick={async () => {
              clearTimeout(timeoutRef.current); // Cancel auto-delete if active
              const restored = await onUndo(notification.id);
              if (restored) {
                onRestore(restored, index); // ✅ reinsert at the original index
                closeToast();
                toast.success("Undo successful!");
              }
            }}
          >
            Undo
          </button>
        </div>
      ),
      {
        autoClose: 3000,
        onClose: () => {
          // Final removal already done via parent
        },
      }
    );
  };

  if (isHidden) return null;

  return (
    <li
      className={`list-group-item d-flex justify-content-between align-items-center ${
        notification.is_read ? "list-group-item-secondary" : ""
      }`}
    >
      {notification.message}
      <div>
        {!notification.is_read && (
          <button
            className="btn btn-sm btn-primary me-2"
            onClick={() => onMarkAsRead(notification.id)}
          >
            Mark as Read
          </button>
        )}
        {notification.is_read && (
          <button
            className="btn btn-sm btn-danger"
            onClick={handleDelete}
            title="Delete Notification"
          >
            🗑️
          </button>
        )}
      </div>
    </li>
  );
};

export default NotificationItem;
